// /pages/FleetManagement/Drivers/EditDriverPage.tsx
import React, { useEffect, useState } from 'react';
import { Box, Card, CardBody, Heading, Spinner, Center } from '@chakra-ui/react';
import { useParams, useNavigate } from 'react-router-dom';
import { AdminLayout } from '@/components/layout/AdminLayout';
import { DriverForm } from '@/components/forms/DriverForm';
import { apiClient } from '@/lib/api/client';
import { useToastNotification } from '@/lib/utils/useToastNotification';

interface Driver {
    id: number;
    first_name: string;
    last_name: string;
    contact_number: string;
    assigned_truck_plate_numbers: string[];
    is_active: number;
}

const EditDriverPage = () => {
    const { id } = useParams();
    const navigate = useNavigate();
    const { showError } = useToastNotification();
    
    const [driver, setDriver] = useState<Driver | null>(null);
    const [loading, setLoading] = useState(true);

    const handleBack = () => navigate('/fleet-management/drivers');

    useEffect(() => {
        const fetchDriver = async () => {
            try {
                const res = await apiClient.get(`/drivers/${id}`);
                setDriver(res.data.data || res.data);
            } catch (err) {
                showError(err);
            } finally {
                setLoading(false);
            }
        };
        fetchDriver();
    }, [id, showError]);

    return (
        <AdminLayout>
            <Box p={6}>
                <Heading size="lg" mb={6}>
                    Edit Driver: {driver ? `${driver.first_name} ${driver.last_name}` : ''}
                </Heading>
                
                <Card variant="outline">
                    <CardBody>
                        {loading ? (
                            <Center py={10}><Spinner color="blue.500" /></Center>
                        ) : (
                            <DriverForm 
                                driverId={Number(id)} 
                                initialData={driver} 
                                onSuccess={handleBack}
                                onCancel={handleBack}
                            />
                        )}
                    </CardBody>
                </Card>
            </Box>
        </AdminLayout>
    );
};

export default EditDriverPage;